module.exports = {
    theme: {
        spacing: {
            none: '0px',
            px: '1px',
            xxxxs: '2px',
            xxxs: '4px',
            xxs: '8px',
            xs: '12px',
            sm: '16px',
            md: '24px',
            lg: '32px',
            xl: '48px',
            xxl: '64px',
            0: '0',
            1: '4px',
            5: '20px',
            8: '32px',
            10: '40px',
            12: '48px',
            15: '60px',
            20: '80px',
            36: '144px',
            'quill-tool': '18px',
            fit: 'fit-content',
        },
        colors: {
            transparent: 'transparent',
            midnight: '#182841',
            charcoal: '#213a47',
            ash: '#4f6c7b',
            elephant: '#7893a1',
            mouse: '#becfd6',
            dust: '#dbe3e7',
            gray: '#e8ecee',
            'light-gray': '#f4f6f6',
            'separator-gray': '#edeff1',
            white: '#ffffff',

            'blue-500': '#0E70FA',

            'grey-100': '#f6f7fb',
            'grey-200': '#f4f6f6',
            'grey-300': '#edeff1',
            'grey-400': '#dbe3e7',
            'grey-500': '#becfd6',
            'grey-600': '#7893a1',
            'grey-700': '#4f6c7b',
            'grey-800': '#213a47',
            'grey-900': '#182841',

            'red-500': '#ec004f',
            'red-700': '#770028',

            grape: '#cb0044',
            grapeBG: '#fde4ec',

            'watermelon-100': '#ffecec',
            'watermelon-400': '#ff5348',
            watermelon: '#ff5348',

            mandarine: '#ff5700',
            gold: '#f3a423',

            lime: '#c4ff62',
            leaf: '#00ad00',
            'leaf-2': '#c2f1c9',
            grass: '#008000',
            grassBG: '#e2f3e4',
            green: '#69f0ae',
            'green-400': '#00d200',
            'green-600': '#05894A',

            cobalt1: '#e9f5fc',
            'cobalt-700': '#0063c8',
            'cobalt-400': '#0093d8',
            'cobalt-300': '#38b8ea',
            'cobalt-200': '#8ed7f3',
            'cobalt-100': '#cbecfa',
            'special-node': '#00e5e4',
            'sky-blue': '#00c6ff',
            ultrablue: '#304ffe',
            azure: '#0073b5',
            blue: '#710be2',

            purple: '#710ce2',
            'purple-100': '#f5e9ff',
            'purple-200': '#e1c1ff',
            'purple-250': '#e7d4fd',
            'purple-300': '#a94cff',
            'purple-400': '#710ce2',
            'purple-500': '#5400b1',
            'purple-700': '#4200a5',

            fuchsia: '#d400ab',
            'fuchsia-100': '#fde8f9',
            'fuchsia-200': '#ffa8ee',
            'fuchsia-300': '#ff56dd',
            'fuchsia-400': '#d400ab',
            'fuchsia-hover': '#c004a0',
            lavender: '#f2e5fe',

            ultragreen: '#69f0ae',
            supergrass: '#46de00', // To be deprecated!
            banana: '#fbea38', // To be deprecated!
            tomato: '#ff0000', // To be deprecated!
            orange: '#ffb400', // To be deprecated!
            red: '#d80021', // To be deprecated!
            pink: '#ff4081', // To be deprecated!
        },

        alertColors: theme => ({
            error: theme('colors.grape'),
            errorBG: theme('colors.grapeBG'),
            warning: theme('colors.mandarine'),
            info: theme('colors.azure'),
            success: theme('colors.leaf'),
            'jds-error': theme('colors.red-500'),
        }),

        screens: {
            /*
             | Class name: .{screen}:{utility}<
             */
            sm: '576px',
            md: '768px',
            lg: '992px',
            xl: '1200px',
            xxl: '1500px',
            'max-xl': { max: '1279px' },
            'max-lg': { max: '1023px' },
            'max-md': { max: '767px' },
            'max-sm': { max: '639px' },
        },

        /*
         | Class name: .font-{name}
         | CSS property: font-family
         */
        fontFamily: {
            default: [
                'hero-new',
                'sans-serif',
            ],
            code: [
                'source-code-pro',
                'monospace',
            ],
        },

        /*
         | Class name: .text-{size}
         | CSS property: font-size
         */
        fontSize: {
            none: '0px',
            root: '14px',
            title: '48px',
            'size-0': '32px',
            'size-1': '22px',
            'size-2': '16px',
            'size-3': '14px',
            'size-4': '13px',
            'size-5': '12px',
            'size-6': '11px',
            'size-7': '10px',
            md: '18px',
        },

        /*
         | Class name: .font-{weight}
         | CSS property: font-weight
         */
        fontWeight: {
            light: 200,
            regular: 400,
            medium: 500,
            semibold: 600,
            bold: 700,
        },

        /*
         | Class name: .leading-{size}
         | CSS property: line-height
         */
        lineHeight: {
            none: 1,
            1: 'calc(1em + 10px)',
            2: 'calc(1em + 8px)',
            3: 'calc(1em + 6px)',
            4: 'calc(1em + 5px)',
            5: 'calc(1em + 4px)',
            6: 'calc(1em + 5px)',
            7: 'calc(1em + 4px)',
            base: 1.4,
            'form-label': '30px',
        },

        /*
         | Class name: .tracking-{size}
         | CSS property: letter-spacing
         */
        letterSpacing: {
            tight: '-0.05em',
            normal: '0',
            wide: '0.05em',
        },

        /*
         | Class name: .text-{color}
         | CSS property: color
         */
        textColor: theme => ({
            ...theme('colors'),
            ...theme('alertColors'),
        }),

        /*
         | Class name: .bg-{color}
         | CSS property: background-color
         */
        backgroundColor: theme => ({
            'zoodiac-blue': 'rgb(22, 36, 59)',
            'midnight-8': '#435369',
            errorBG: theme('colors.grapeBG'),
            successBG: theme('colors.grassBG'),
            ...theme('colors'),
            ...theme('alertColors'),
        }),

        /*
         | Class name: .bg-{size}
         | CSS property: background-size
         */
        backgroundSize: {
            auto: 'auto',
            cover: 'cover',
            contain: 'contain',
        },

        /*
         | Class name: .border{-side?}{-width?}
         | CSS property: border-width
         */
        borderWidth: {
            DEFAULT: '1px',
            0: '0',
            2: '2px',
            4: '4px',
            6: '6px',
        },

        /*
         | Class name: .border-{color}
         | CSS property: border-color
         */
        borderColor: theme => ({
            DEFAULT: theme('colors.grey-light'),
            ...theme('colors'),
            ...theme('alertColors'),
        }),

        /*
         | Class name: .rounded{-side?}{-size?}
         | CSS property: border-radius
         */
        borderRadius: {
            none: '0',
            sm: '2px',
            DEFAULT: '4px',
            md: '6px',
            lg:'8px',
            xl: '12px',
            'bot-option': '22px',
            tag: '30px',
            half: '50%',
            full: '9999px',
        },

        /*
         | Class name: .w-{size}
         | CSS property: width
         */
        width: theme => ({
            auto: 'auto',
            px: '1px',
            none: '0px',
            1: '4px',
            2: '8px',
            3: '12px',
            4: '16px',
            5: '20px',
            6: '24px',
            8: '32px',
            10: '40px',
            12: '48px',
            14: '56px',
            16: '64px',
            24: '96px',
            28: '112px',
            32: '128px',
            42: '168px',
            48: '192px',
            50: '200px',
            54: '216px',
            64: '256px',
            68: '272px',
            72: '288px',
            75: '300px',
            90: '360px',
            105: '420px',
            128: '512px',
            150: '600px',
            160: '640px',
            200: '800px',
            '1/2': '50%',
            '1/3': '33.33333%',
            '2/3': '66.66667%',
            '1/4': '25%',
            '3/4': '75%',
            '1/5': '20%',
            '2/5': '40%',
            '3/5': '60%',
            '4/5': '80%',
            '1/6': '16.66667%',
            '5/6': '83.33333%',
            full: '100%',
            screen: '100vw',
            icon: '18px',
            'icon-lg': '72px',
            navigator: '320px',
            'full-sidebar': 'calc(100% - 60px)',
            ...theme('spacing'),
            inherit: 'inherit',
        }),

        /*
         | Class name: .h-{size}
         | CSS property: height
         */
        height: theme => ({
            none: '0px',
            auto: 'auto',
            inherit: 'inherit',
            px: '1px',
            1: '4px',
            2: '8px',
            3: '12px',
            4: '16px',
            5: '20px',
            6: '24px',
            8: '32px',
            10: '40px',
            12: '48px',
            14: '56px',
            15: '60px',
            16: '64px',
            20: '80px',
            24: '96px',
            28: '112px',
            32: '128px',
            48: '192px',
            55: '220px',
            64: '256px',
            72: '288px',
            96: '384px',
            100: '400px',
            full: '100%',
            screen: '100vh',
            '1/3': '33.33333%',
            'screen-80': '80vh',
            icon: '18px',
            'icon-lg': '72px',
            ...theme('spacing'),
        }),

        /*
         | Class name: .min-w-{size}
         | CSS property: min-width
         */
        minWidth: {
            0: '0',
            24: '96px',
            32: '128px',
            42: '168px',
            48: '192px',
            50: '200px',
            64: '288px',
            128: '512px',
            sm: '30rem',
            md: '40rem',
            lg: '50rem',
            full: '100%',
            auto: 'auto',
        },

        /*
         | Class name: .min-h-{size}
         | CSS property: min-height
         */
        minHeight: theme => ({
            0: '0',
            10: '40px',
            12: '48px',
            16: '64px',
            32: '128px',
            100: '400px',
            150: '600px',
            full: '100%',
            screen: '100vh',
            ...theme('spacing'),
        }),

        /*
         | Class name: .max-w-{size}
         | CSS property: max-width
         */
        maxWidth: {
            xs: '20rem',
            sm: '30rem',
            md: '40rem',
            lg: '50rem',
            xl: '60rem',
            6: '24px',
            10: '40px',
            12: '48px',
            25: '100px',
            48: '192px',
            64: '256px',
            75: '300px',
            100: '400px',
            150: '600px',
            156: '624px',
            175: '700px',
            200: '800px',
            300: '1200px',
            '2xl': '70rem',
            '3xl': '80rem',
            '4xl': '90rem',
            '5xl': '100rem',
            '1/2': '50%',
            '2/3': '66%',
            full: '100%',

        },

        /*
         | Class name: .max-h-{size}
         | CSS property: max-height
         */
        maxHeight: {
            none: 'none',
            10: '40px',
            25: '100px',
            full: '100%',
            '1/2': '50%',
            screen: '100vh',
        },

        /*
         | Class name: .p{side?}-{size}
         | CSS property: padding
         */
        padding: theme => ({
            none: '0px',
            xxxs: '4px',
            xxs: '8px',
            xs: '12px',
            sm: '16px',
            md: '24px',
            lg: '32px',
            xl: '48px',
            xxl: '64px',
            sidebar: '60px',
            'sidebar-wide': '256px',
            1: '1px',
            5: '20px',
            10: '40px',
            24: '96px',
            ...theme('spacing'),
        }),

        /*
         | Class name: .m{side?}-{size}
         | for negative margins use .-m{side?}-{size}
         | CSS property: margin
         */
        margin: theme => ({
            auto: 'auto',
            none: '0px',
            xxxxs: '2px',
            xxxs: '4px',
            xxs: '8px',
            xs: '12px',
            sm: '16px',
            md: '24px',
            lg: '32px',
            xl: '48px',
            xxl: '64px',
            5: '20px',
            10: '40px',
            20: '80px',
            '-xxxs': '-4px',
            '-xxs': '-8px',
            '-xs': '-12px',
            '-sm': '-16px',
            '-md': '-24px',
            '-lg': '-32px',
            '-xl': '-48px',
            '-xxl': '-64px',
            '-5': '-20px',
            '-10': '-40px',
            '-23': '-92px',
            '-24': '-96px',
            ...theme('spacing'),
        }),

        /*
         | If a `default` shadow is provided, it will be made available as the non-
         | suffixed `.shadow` utility.
         |
         | Class name: .shadow-{size?}
         | CSS property: box-shadow
         */
        boxShadow: {
            l1: '0 2px 16px 0 rgba(33, 58, 71, 0.1)',
            l2: '0 2px 8px 0 rgba(33, 58, 71, 0.2)',
            DEFAULT: '0 2px 4px 0 rgba(0,0,0,0.1)',
            md: '0 4px 8px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.08)',
            lg: '0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08)',
            inner: 'inset 0 2px 4px 0 rgba(0,0,0,0.06)',
            'inner-deep': 'inset 0 -10px 20px 0 rgba(0,0,0,0.2)',
            outline: '0 0 0 3px rgba(52,144,220,0.5)',
            cog: '0 2px 10px 0 rgba(33,58,71,0.3)',
            none: 'none',
            'scroll-left': '5px 0 12px 0 rgba(33, 58, 71, 0.2)',
            'scroll-right': '-5px 0 12px 0 rgba(33, 58, 71, 0.2)',
        },

        /*
         | Class name: .z-{index}
         | CSS property: z-index
         */
        zIndex: {
            auto: 'auto',
            0: 0,
            1: 1,
            2: 2,
            10: 10,
            20: 20,
            30: 30,
            40: 40,
            50: 50,
            100: 100,
            200: 200,
            500: 500,
            1000: 1000,
        },

        /*
         | Class name: .opacity-{name}
         | CSS property: opacity
         */
        opacity: {
            0: '0',
            8: '0.08',
            10: '0.1',
            20: '.2',
            25: '.25',
            50: '.5',
            70: '.7',
            75: '.75',
            80: '0.8',
            100: '1',
        },

        /*
         | Here is where you define your SVG fill colors. By default we just provide
         | `fill-current` which sets the fill to the current text color. This lets you
         | specify a fill color using existing text color utilities and helps keep the
         | generated CSS file size down.
         |
         | Class name: .fill-{name}
         | CSS property: fill
         */
        fill: {
            current: 'currentColor',
        },

        /*
         | Here is where you define your SVG stroke colors. By default we just provide
         | `stroke-current` which sets the stroke to the current text color. This lets
         | you specify a stroke color using existing text color utilities and helps
         | keep the generated CSS file size down.
         |
         | Class name: .stroke-{name}
         | CSS property: stroke
         */
        stroke: {
            current: 'currentColor',
        },

        transitionTimingFunction: {
            'ease-in-expo': 'cubic-bezier(0.95, 0.05, 0.795, 0.035)',
            'ease-out-expo': 'cubic-bezier(0.19, 1, 0.22, 1)',
        },

    },

    variants: {
        backgroundColor: ['responsive', 'hover', 'focus', 'disabled'],
        borderColor: ['responsive', 'hover', 'focus'],
        borderRadius: ['responsive'],
        borderStyle: ['responsive'],
        borderWidth: ['responsive'],
        cursor: ['responsive'],
        display: ['responsive'],
        flexDirection: ['responsive'],
        flexWrap: ['responsive'],
        alignItems: ['responsive'],
        alignSelf: ['responsive'],
        justifyContent: ['responsive'],
        alignContent: ['responsive'],
        flex: ['responsive'],
        flexGrow: ['responsive'],
        flexShrink: ['responsive'],
        float: ['responsive'],
        fontFamily: ['responsive'],
        fontWeight: ['responsive', 'hover', 'focus'],
        lineHeight: ['responsive'],
        margin: ['responsive', 'hover', 'focus'],
        padding: ['responsive'],
        position: ['responsive'],
        inset: ['responsive'],
        fill: [],
        stroke: [],
        textAlign: ['responsive'],
        textColor: ['responsive', 'hover', 'focus'],
        fontSize: ['responsive'],
        fontStyle: ['responsive', 'hover', 'focus'],
        fontSmoothing: ['responsive', 'hover', 'focus'],
        textDecoration: ['responsive', 'hover', 'focus'],
        textTransform: ['responsive', 'hover', 'focus'],
        verticalAlign: ['responsive'],
        visibility: ['responsive'],
        whitespace: ['responsive'],
        wordBreak: ['responsive'],
        width: ['responsive'],
        zIndex: ['responsive'],
        height: ['responsive'],
    },

    purge: [
        './apps/**/*.vue',
        './common/**/*.ts',
        './common/**/*.vue',
        './ui/**/*.vue',
        './packages/**/*.vue',
    ],

    /*
     | Here is where you can register any plugins you'd like to use in your
     | project. Tailwind's built-in `container` plugin is enabled by default to
     | give you a Bootstrap-style responsive container component out of the box.
     |
     | Be sure to view the complete plugin documentation to learn more about how
     | the plugin system works.
     */

    plugins: [
        function ({ addUtilities, theme }) {
            const dashedGradient = {
                'background-image': `linear-gradient(to right, ${theme('colors.elephant')} 50%, transparent 50%),
                    linear-gradient(to right, ${theme('colors.elephant')} 50%, transparent 50%),
                    linear-gradient(to bottom, ${theme('colors.elephant')} 50%, transparent 50%),
                    linear-gradient(to bottom, ${theme('colors.elephant')} 50%, transparent 50%)`,
                'background-position': 'left top, left bottom, left top, right top',
                'background-repeat': 'repeat-x, repeat-x, repeat-y, repeat-y',
                'background-size': '15px 1px, 15px 1px, 1px 15px, 1px 15px',
            };
            addUtilities({ '.dashed-gradient': dashedGradient });
            addUtilities({
                '.color-inherit': {
                    color: 'inherit',
                },
            }, {
                variants: ['active', 'hover', 'focus'],
            });

            addUtilities({
                '.color-current': {
                    color: 'currentColor',
                },
            });

            addUtilities({
                '.bg-current': {
                    'background-color': 'currentColor',
                },
            }, {
                variants: ['hover'],
            });

            addUtilities({
                '.border-current': {
                    'border-color': 'currentColor',
                },
            });

            addUtilities({
                '.contents': {
                    display: 'contents',
                },
            });

            addUtilities({
                '.scroll-auto': {
                    'scroll-behavior': 'auto',
                },
                '.scroll-smooth': {
                    'scroll-behavior': 'smooth',
                },
            });

            addUtilities({
                '.touch-none': {
                    'touch-action': 'none',
                },
            });
        },
        function ({ addUtilities, theme }) {
            addUtilities(Object.keys(theme('colors')).reduce((classes, colorName) => {
                classes[`.text-decoration-${colorName}`] = {
                    'text-decoration-color': theme(`colors.${colorName}`),
                };

                return classes;
            }, {}));
        },
        ({ addUtilities, theme }) => {
            addUtilities({
                '.grid-rows-3-center': {
                    'grid-template-rows': '1fr auto 1fr',
                },
            });
        },
        require('@tailwindcss/line-clamp'),
    ],
};

